'use client'
import React from 'react';
import { Card, CardHeader, CardContent, Divider, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';


const ChildCard = ({ title, sectionTitle, sx, children, codeModel }) => {

  const theme = useTheme();

  return (
    <Card sx={{ padding: 0, borderColor: (theme) => theme.palette.divider }} variant="outlined">
      {title && (
        <>
          <CardHeader title={title} action={codeModel} />
          <Divider />{' '}
        </>
      )}
      <CardContent sx={sx}>
        {sectionTitle && (
          <Typography
            variant="h6"
            component="h2"
            sx={{
              marginBottom: theme.spacing(2),
              display: 'flex',
              alignItems: 'center',
              gap: theme.spacing(1),
              fontWeight: 600,
              color: theme.palette.primary.main,
            }}
          >
            {sectionTitle}
          </Typography>
        )}
        {children}
      </CardContent>
    </Card>
  );
}

export default ChildCard;